import { useCallback } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ComponentEmptyButton,
  ComponentStartCover,
} from '../shared/component-parts';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import { EditProps } from './video.constants';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';

const VideoEdit = (props: EditProps) => {
  const { sectionId, properties, id, type, stimulusResourceProperties } = props;

  const { openDrawer, activeComponent } = useActivityBuilderContext();
  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const { style, setContainerElement, elementDimensions } =
    useContainerDimensions({
      aspectRatio: 16 / 9,
    });

  const handleHeightUpdate = useCallback(
    (width: number, height: number) => {
      const dimensionData = {
        ...properties.dimensionData,
        width,
        height: Math.floor(height),
      };
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData,
            },
          },
        },
        properties: {
          ...properties,
          dimensionData,
        },
        typename: 'ActivitiesVideoComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return stimulusResourceProperties ? (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === props.id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleHeightUpdate}
    >
      <ComponentAbsoluteWrapper ref={setContainerElement}>
        <ComponentStartCover
          type={type}
          buttonLabel="Play"
          resourceName={props.stimulusResourceProperties?.resourceName || ''}
          backgroundImage={
            stimulusResourceProperties?.xlCoverImageUrls?.length
              ? getClosestImageUrl({
                  imageUrls: stimulusResourceProperties.xlCoverImageUrls,
                  containerSize: elementDimensions?.width
                    ? Math.max(
                        elementDimensions.width,
                        elementDimensions.height
                      )
                    : window.innerWidth,
                  quality: ImageDisplayQuality.High,
                })
              : stimulusResourceProperties?.coverImage?.original
          }
          style={style}
          data-selector="btn-play"
        />
      </ComponentAbsoluteWrapper>
    </ComponentDimensions>
  ) : (
    <>
      <ComponentEmptyButton
        iconId="video"
        onClick={() => openDrawer({ componentId: props.id })}
        buttonText="Add Video"
      />
    </>
  );
};

export default VideoEdit;
